module.exports = {
  name: {
    description: 'nome ou razao social'
  },
  cpfCnpj: {
    description: 'cpf ou cnpj'
  },
  email: {
    description: 'email',
    optional: true
  },
  bank: {
    description: 'banco'
  },
  agency: {
    description: 'agencia'
  },
  agencyDigit: {
    description: 'digito da agencia',
    optional: true
  },
  account: {
    description: 'conta'
  },
  accountDigit: {
    description: 'digito da conta'
  },
  accountType: {
    description: 'tipo de conta corrente ou poupanca'
  },
  value: {
    description: 'valor'
  },
  integrationId: {
    description: 'id integracao',
    optional: true
  },
  paymentDate: {
    description: 'data de agendamento',
    optional: true
  },
  paymentMethod: {
    description: 'metodo de pagamento',
    optional: true
  },
  pixDescription: {
    description: 'descricao pix',
    optional: true
  }
};
